import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { ARTICLES } from "@/data/journal";

export const JournalPreview = () => (
  <section data-testid="journal-preview" className="max-w-7xl mx-auto px-6 md:px-10 pb-28 md:pb-40">
    <Reveal>
      <p className="text-xs font-medium tracking-[0.25em] uppercase text-[#2C241E]/50 mb-4">
        06 / Journal
      </p>
      <h2
        data-testid="journal-preview-headline"
        className="font-display text-4xl md:text-6xl tracking-tighter text-[#2C241E] mb-14"
      >
        Notes From the Treatment Room.
      </h2>
    </Reveal>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
      {ARTICLES.map((a, i) => (
        <Reveal key={a.id} delay={i * 0.08}>
          <Link
            to={`/journal`}
            data-testid={`journal-card-${a.id}`}
            className="group block rounded-2xl border border-[#2C241E]/10 bg-[#F3F1EB] p-7 h-full transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-lg"
          >
            <div className="flex items-center justify-between mb-6">
              <span className="text-[10px] font-medium tracking-[0.2em] uppercase text-[#A07856]">
                {a.category}
              </span>
              <ArrowUpRight
                size={16}
                strokeWidth={1.75}
                className="text-[#2C241E]/40 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
              />
            </div>
            <h3 className="font-display text-2xl leading-snug text-[#2C241E]">{a.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-[#2C241E]/60 line-clamp-3">
              {a.excerpt}
            </p>
            <p className="mt-6 text-[10px] font-medium tracking-[0.2em] uppercase text-[#2C241E]/40">
              {a.date}
            </p>
          </Link>
        </Reveal>
      ))}
    </div>
    <Reveal delay={0.3}>
      <Link
        to="/journal"
        data-testid="journal-link"
        className="mt-10 inline-flex items-center gap-2 text-xs md:text-sm font-medium tracking-[0.2em] uppercase text-[#2C241E]/70 transition-colors duration-200 hover:text-[#2C241E]"
      >
        Read the journal
        <ArrowRight size={16} strokeWidth={1.75} />
      </Link>
    </Reveal>
  </section>
);
